// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XtzHX","colMin":"styles_colMin__YHeKL"};